// @ts-nocheck
import { Component } from 'react';
import { ApplyPluginsType } from 'umi';
import dva from 'dva';
// @ts-ignore
import createLoading from '/builds/xiaoduo-front/xiaoduo-simulation-training/node_modules/dva-loading/dist/index.esm.js';
import { plugin, history } from '../core/umiExports';
import ModelGlobal0 from '/builds/xiaoduo-front/xiaoduo-simulation-training/src/models/global.ts';
import ModelRobot1 from '/builds/xiaoduo-front/xiaoduo-simulation-training/src/models/robot.ts';
import ModelUser2 from '/builds/xiaoduo-front/xiaoduo-simulation-training/src/models/user.ts';
import ModelModel3 from '/builds/xiaoduo-front/xiaoduo-simulation-training/src/pages/admit/information/model.ts';
import ModelModel4 from '/builds/xiaoduo-front/xiaoduo-simulation-training/src/pages/admit/train/model.ts';
import ModelModel5 from '/builds/xiaoduo-front/xiaoduo-simulation-training/src/pages/case/dialog/model.ts';
import ModelModel6 from '/builds/xiaoduo-front/xiaoduo-simulation-training/src/pages/case/material/model.ts';
import ModelModel7 from '/builds/xiaoduo-front/xiaoduo-simulation-training/src/pages/case/story/model.ts';
import ModelModel8 from '/builds/xiaoduo-front/xiaoduo-simulation-training/src/pages/dashboard/model.ts';
import ModelModel9 from '/builds/xiaoduo-front/xiaoduo-simulation-training/src/pages/person/appraise/model.ts';
import ModelModel10 from '/builds/xiaoduo-front/xiaoduo-simulation-training/src/pages/person/manage/model.ts';
import ModelModel11 from '/builds/xiaoduo-front/xiaoduo-simulation-training/src/pages/person/shortcut/model.ts';
import ModelModel12 from '/builds/xiaoduo-front/xiaoduo-simulation-training/src/pages/person/user/model.ts';
import ModelModel13 from '/builds/xiaoduo-front/xiaoduo-simulation-training/src/pages/toolsPage/model.ts';

let app:any = null;

export function _onCreate(options = {}) {
  const runtimeDva = plugin.applyPlugins({
    key: 'dva',
    type: ApplyPluginsType.modify,
    initialValue: {},
  });
  app = dva({
    history,
    
    ...(runtimeDva.config || {}),
    // @ts-ignore
    ...(typeof window !== 'undefined' && window.g_useSSR ? { initialState: window.g_initialProps } : {}),
    ...(options || {}),
  });
  
  app.use(createLoading());
  (runtimeDva.plugins || []).forEach((plugin:any) => {
    app.use(plugin);
  });
  app.model({ namespace: 'global', ...ModelGlobal0 });
app.model({ namespace: 'robot', ...ModelRobot1 });
app.model({ namespace: 'user', ...ModelUser2 });
app.model({ namespace: 'model', ...ModelModel3 });
app.model({ namespace: 'model', ...ModelModel4 });
app.model({ namespace: 'model', ...ModelModel5 });
app.model({ namespace: 'model', ...ModelModel6 });
app.model({ namespace: 'model', ...ModelModel7 });
app.model({ namespace: 'model', ...ModelModel8 });
app.model({ namespace: 'model', ...ModelModel9 });
app.model({ namespace: 'model', ...ModelModel10 });
app.model({ namespace: 'model', ...ModelModel11 });
app.model({ namespace: 'model', ...ModelModel12 });
app.model({ namespace: 'model', ...ModelModel13 });
  return app;
}

export function getApp() {
  return app;
}

/**
 * whether browser env
 * 
 * @returns boolean
 */
function isBrowser(): boolean {
  return typeof window !== 'undefined' &&
  typeof window.document !== 'undefined' &&
  typeof window.document.createElement !== 'undefined'
}

export class _DvaContainer extends Component {
  constructor(props: any) {
    super(props);
    // run only in client, avoid override server _onCreate()
    if (isBrowser()) {
      _onCreate()
    }
  }

  componentWillUnmount() {
    let app = getApp();
    app._models.forEach((model:any) => {
      app.unmodel(model.namespace);
    });
    app._models = [];
    try {
      // 释放 app，for gc
      // immer 场景 app 是 read-only 的，这里 try catch 一下
      app = null;
    } catch(e) {
      console.error(e);
    }
  }

  render() {
    let app = getApp();
    app.router(() => this.props.children);
    return app.start()();
  }
}
